<template>
  <span v-if="chips.length" class="lesson-tags">
    <span
      v-for="chip in chips"
      :key="chip.label"
      class="lesson-tag"
      :style="{ '--chip': chip.color }"
      >{{ chip.label }}</span
    >
  </span>
</template>

<script>
import { categoryColor, categoryLabel } from "@/shared/courseTiers";

// Chips de uma aula: a categoria (com a cor dela) e os marcadores de ementa
// que o administrativo marca ao subir a aula. Card 86ak2ncuv: e a mesma
// leitura em todo lugar onde o professor escolhe ou lista assuntos.
export default {
  name: "LessonTagChips",
  props: {
    category: {
      type: String,
      default: null,
    },
    pre: {
      type: Boolean,
      default: false,
    },
    optional: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chips() {
      const chips = [];

      if (this.category) {
        chips.push({
          label: categoryLabel(this.category),
          color: categoryColor(this.category),
        });
      }

      if (this.pre) {
        chips.push({ label: this.$t("course.preSyllabus"), color: "#5B4B8A" });
      }

      if (this.optional) {
        chips.push({ label: this.$t("course.optional"), color: "#7C7C7F" });
      }

      return chips;
    },
  },
};
</script>

<style scoped>
.lesson-tags {
  display: inline-flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  gap: 4px;
}

.lesson-tag {
  border: 1px solid var(--chip);
  border-radius: 999px;
  color: var(--chip);
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1;
  padding: 3px 8px;
  white-space: nowrap;
}
</style>
